import { ListMusic, Pause, Play } from 'lucide-react';
import { Playlist } from '../../../context/PlaylistsContext';
import './Cards.css';

interface Props {
    playlist: Playlist;
    onClick: (playlist: Playlist) => void;
    onPlay?: (playlist: Playlist) => void;
    isPlaying?: boolean;
}

export function PlaylistCard({ playlist, onClick, onPlay, isPlaying }: Props): React.JSX.Element {
    return (
        <div className="gridCard" onClick={() => onClick(playlist)}>
            <div className="gridCardArt">
                <ListMusic size={28} strokeWidth={2.75} />
                {onPlay && (
                    <button
                        className={`gridCardPlayButton ${isPlaying ? 'gridCardPlayButtonVisible' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlay(playlist);
                        }}
                        aria-label={isPlaying ? `Pause ${playlist.name}` : `Play ${playlist.name}`}
                    >
                        {isPlaying ? (
                            <Pause size={16} strokeWidth={2.75} fill="currentColor" />
                        ) : (
                            <Play size={16} strokeWidth={2.75} fill="currentColor" />
                        )}
                    </button>
                )}
            </div>
            <div className="gridCardMeta">
                <span className="gridCardTitle">{playlist.name}</span>
                {playlist.description && <span className="gridCardSubtitle">{playlist.description}</span>}
            </div>
        </div>
    );
}
